var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from 'react';
import InputAdapter from '../InputAdapter';
import Icon from '../../Icon';

import PropTypes from 'prop-types';

export var Select = function (_Component) {
  _inherits(Select, _Component);

  function Select() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Select);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Select.__proto__ || Object.getPrototypeOf(Select)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      isFocusing: false
    }, _this._generateOptions = function () {
      var options = _this.props.options;


      return options.map(function (item, index) {
        return React.createElement(
          'option',
          { key: index, value: item.value },
          item.label || item
        );
      });
    }, _this._handleFocus = function (event) {
      var onFocus = _this.props.onFocus;


      _this.setState({
        isFocusing: true
      });

      onFocus && onFocus(event);
    }, _this._handleBlur = function (event) {
      var onBlur = _this.props.onBlur;


      _this.setState({
        isFocusing: false
      });

      onBlur && onBlur(event);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Select, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          label = _props.label,
          error = _props.error,
          required = _props.required,
          disabled = _props.disabled,
          className = _props.className,
          defaultOptionLabel = _props.defaultOptionLabel,
          errortext = _props.errortext,
          value = _props.value,
          others = _objectWithoutProperties(_props, ['label', 'error', 'required', 'disabled', 'className', 'defaultOptionLabel', 'errortext', 'value']);

      var isFocusing = this.state.isFocusing;

      var hasValue = !!value;

      return React.createElement(
        'div',
        {
          className: 'tg_input ' + className + ' ' + (isFocusing ? 'input_focus' : '') + ' ' + (hasValue ? 'tg_input_value' : '') + ' ' + (error ? 'error' : '') + ' ' + (label ? 'has_title' : '') },
        React.createElement(
          'div',
          { className: 'input-wrapper' },
          React.createElement(
            'select',
            _extends({
              value: value,
              disabled: disabled
            }, others, {
              onFocus: this._handleFocus,
              onBlur: this._handleBlur,
              required: required }),
            React.createElement(
              'option',
              null,
              defaultOptionLabel
            ),
            this._generateOptions()
          ),
          React.createElement(
            'div',
            { className: 'select-icon' + (disabled ? ' opa-d5' : '') },
            React.createElement(Icon, { icon: 'chevron-down' })
          ),
          React.createElement(
            'div',
            {
              className: 'input_title' + (disabled ? ' opa-d5' : '') },
            label + ' ' + (required ? '*' : '')
          )
        ),
        React.createElement('div', { className: 'bottom-line' }),
        errortext && React.createElement(
          'div',
          { className: 'error-message' },
          errortext
        )
      );
    }
  }]);

  return Select;
}(Component);

Select.defaultProps = {
  defaultOptionLabel: ''
};

Select.propTypes = {
  /** Array of objects containing all options with value and label */
  options: PropTypes.array.isRequired,
  /** Title of the input field */
  label: PropTypes.string,
  /** Type of value */
  type: PropTypes.string,
  /** The validation error message */
  error: PropTypes.string,
  /** Name associated with each input field */
  name: PropTypes.string.isRequired,
  /** Boolean props deciding whether the is required to have a value or not */
  required: PropTypes.bool,
  /** Boolean or String value deciding whether the field is disabled or not */
  disabled: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  /** Optional description text */
  description: PropTypes.string,
  /** Placeholder text used on the input */
  placeholder: PropTypes.string,
  /** Classnames that should be used on the input */
  className: PropTypes.string,
  /** The field value */
  value: PropTypes.string,
  /** The first and default selected option in the list of options */
  defaultOptionLabel: PropTypes.string
};

export default InputAdapter(Select);